import React, { useEffect, useState } from 'react';
import './ChangePasswrd.css'
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../axiosinterceptor';
const PasswordChangeForm = () => {
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigation = useNavigate()
  const [loader, setLoader] = useState(false)
  const [errors,setErrors] = useState({})
  
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => {
    const updatedForm = {
      ...prev,
      [name]: value,
    };

    const updatedErrors = { ...errors };

    // Clear field-specific error when typing
    delete updatedErrors[name];

    // Live confirm password validation
    if (
      (name === "newPassword" || name === "confirmPassword") &&
      updatedForm.confirmPassword &&
      updatedForm.newPassword !== updatedForm.confirmPassword
    ) {
      updatedErrors.confirmPassword =
        "New password and confirm password do not match";
    }

    // Remove mismatch error when corrected
    if (
      updatedForm.newPassword &&
      updatedForm.confirmPassword &&
      updatedForm.newPassword === updatedForm.confirmPassword
    ) {
      delete updatedErrors.confirmPassword;
    }

    setErrors(updatedErrors);

    return updatedForm;
  });
};

const validateForm = () => {
  const newErrors = {};

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  if (!formData.currentPassword.trim()) {
    newErrors.currentPassword = "Current password is required";
  }

  if (!formData.newPassword.trim()) {
    newErrors.newPassword = "New password is required";
  } else if (!passwordRegex.test(formData.newPassword)) {
    newErrors.newPassword =
      "Password must be at least 8 characters and include uppercase, lowercase, number, and one special character (@$!%*?&) with no spaces.";
  }

  if (!formData.confirmPassword.trim()) {
    newErrors.confirmPassword = "Confirm password is required";
  } else if (formData.newPassword !== formData.confirmPassword) {
    newErrors.confirmPassword = "Passwords do not match";
  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

const passwrdChange = async () => {
   const accessToken = sessionStorage.getItem("accessToken");
  
  try {
    const response = await axiosInstance.post("/change_password_ics_v1", {
    accessToken:accessToken,
    old_password:formData.currentPassword,
    new_password:formData.newPassword,
    confirm_password:formData.newPassword
    });
    return response
  } catch (error) {
    if(error.response.status === 400){
      if(error.response.data.error === "Password change failed: An error occurred (LimitExceededException) when calling the ChangePassword operation: Attempt limit exceeded, please try after some time."){
      toast.error("Maximum attempts exceeded. Please try again after some time.") 
      }else{
         toast.error(error.response.data.message)
      }
    }else{
      toast.error("internal server")
    }
    console.log('Error fetching table data:', error.response.status);
    throw error;
    
  }
};


  const handleSubmit =async () => {
    if(!validateForm()) return
     setLoader(true)
    try{
      const response = await passwrdChange()
      toast.success(response.data.message)
      
      
      setTimeout(() => {
         navigation('/login');
         sessionStorage.clear();
        window.location.reload();
    }, 3000)

      setFormData({
        currentPassword:"",
        newPassword:"",
        confirmPassword:""
      })
      setErrors({})
    }catch(error){
      console.error(console.error)
    }finally{
      setLoader(false)
    }
   
  };
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);
  return (
    <div className='change-passwrd-container'>
      <div className='formCard'>
        
        <div className='iconContainer'>
          <div className='lockIcon'>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM12 17c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM15.1 8H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" fill="#6366f1"/>
            </svg>
          </div>
        </div>

        
        <h1 className="title">Change Password</h1>
        <p className='subtitle'>Update your password to keep your account secure</p>

        
        <div className='form'>
          
          <div className='fieldGroup'>
            <label className='change-label-password'>Current Password</label>
            <div className='inputContainer'>
              <input
                type={showCurrentPassword ? "text" : "password"}
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleInputChange}
                placeholder="Enter your current password"
                // className='change-passwrd-input'
                style={styles.input}
                className='change-password-input'
              />
              <button
                type="button"
                onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                // style={styles.eyeButton}
                className='eyeButton'
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {showCurrentPassword ? (
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="#9ca3af"/>
                  ) : (
                    <>
                      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="#9ca3af"/>
                    </>
                  )}
                </svg>
              </button>
            </div>
          </div>
          {errors.currentPassword && <p className="errorText">{errors.currentPassword}</p>}

          
          <div className='fieldGroup'>
            <label className='change-label-password'>New Password</label>
            <div className='inputContainer'>
              <input
                type={showNewPassword ? "text" : "password"}
                name="newPassword"
                value={formData.newPassword}
                onChange={handleInputChange}
                placeholder="Enter your new password"
                style={styles.input}
                className='change-password-input'
            //   className='change-passwrd-input'
              />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
           className='eyeButton'
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {showNewPassword ? (
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="#9ca3af"/>
                  ) : (
                    <>
                      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="#9ca3af"/>
                    </>
                  )}
                </svg>
              </button>
            </div>
          </div>
          {errors.newPassword && <p className="errorText">{errors.newPassword}</p>}

          
          <div className='fieldGroup'>
            <label className='change-label-password'>Confirm New Password</label>
            <div className='inputContainer'>
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                placeholder="Confirm your new password"
                style={styles.input}
                className='change-password-input'
                // className='change-passwrd-input'
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className='eyeButton'
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  {showConfirmPassword ? (
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="#9ca3af"/>
                  ) : (
                    <>
                      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" fill="#9ca3af"/>
                    </>
                  )}
                </svg>
              </button>
            </div>
          </div>
          {errors.confirmPassword && <p className="errorText">{errors.confirmPassword}</p>}

          
          <button type="button" onClick={handleSubmit} className='submitButton'>
            {loader ? <span className='passward-loader'></span>:" Change Password"}
           
          </button>
        </div>

      
       
      </div>
    </div>
  );
};



// Add hover effects

 const styles = {
input: {
   width: '100%',
   padding: '12px 16px',
   paddingRight: '48px',
   fontSize: '16px',
   border: '2px solid #e5e7eb',
   borderRadius: '8px',
   outline: 'none',
   transition: 'border-color 0.2s ease',
   boxSizing: 'border-box',
   backgroundColor: 'white'
 },
}
    
const originalSubmitButton = styles.submitButton;
styles.submitButton = {
  ...originalSubmitButton,
  ':hover': {
    backgroundColor: '#4f46e5'
  }
};

// Add focus styles for inputs
const originalInput = styles.input;
styles.input = {
  ...originalInput,
  ':focus': {
    borderColor: '#6366f1',
    boxShadow: '0 0 0 3px rgba(99, 102, 241, 0.1)'
  },
  "&::placeholder":{
  fontFamily: "Founders Grotesk"
  }
};

export default PasswordChangeForm;